export default "__VITE_ASSET__laQ5p2yY__"